import {Pipe, PipeTransform} from '@angular/core';
import {GameGenderDBChoices, GameGenderUIChoices} from '../../enums/game-gender.enum';

@Pipe({
  name: 'GameGender'
})
export class GameGenderPipe implements PipeTransform {
  transform(value: any, limit?: number) {
    if (value != null && value === GameGenderDBChoices.males) {
      return GameGenderUIChoices.males;
    }
    if (value != null && value === GameGenderDBChoices.females) {
      return GameGenderUIChoices.females;
    }
    if (value != null && value === GameGenderDBChoices.mixed) {
      return GameGenderUIChoices.mixed;
    }
    return value;
  }
}
